// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12-E4","tabsBox":"styles_tabsBox__1iV_I","createButton":"styles_createButton__3mrTm"};